import { isDataField } from '@eastcoal/formily/exports/core'
import {
  connect,
  mapProps,
  mapReadPretty
} from '@eastcoal/formily/exports/react'

import { OcrBusinessLicense as LocalOcrBusinessLicense } from '../../components/OcrBusinessLicense'

export const OcrBusinessLicense = connect(
  LocalOcrBusinessLicense,
  mapReadPretty(LocalOcrBusinessLicense, {
    disabled: true
  }),
  mapProps((props, field) => {
    return {
      ...props,
      onOcrError(error) {
        if (isDataField(field)) {
          field.selfErrors = [error.message]
        }
      }
    }
  })
)
